import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import utc from "dayjs/plugin/utc";

import "dayjs/locale/sv";

const dateFormats = {
  date: "D MMM YYYY",
  time: "HH:mm",
  dateTime: "D MMM YYYY HH:mm:ss",
};

dayjs.extend(relativeTime);
dayjs.extend(utc);

type DateInput = string | Date | undefined | null;

export const formatDate = (
  date: DateInput,
  format: "date" | "time" | "dateTime" = "date",
) => {
  if (!date) return "-";
  const d = dayjs(date);

  return d.format(dateFormats[format]);
};

export const formatDateRelative = (date: DateInput, lang: string) =>
  date ? dayjs(date).locale(lang).fromNow() : "-";

export const isPastDate = (date: DateInput) =>
  date ? dayjs(date).isBefore(dayjs()) : false;

export const addDays = (date: string | Date, days: number) =>
  dayjs(date).add(days, "day").toDate();

export const toISOString = (date: DateInput) => {
  if (date === null || date === undefined) return null;
  return dayjs(date).startOf("date").utc(true).toISOString();
};

export const isSameDateValue = (date1: DateInput, date2: DateInput) => {
  if (date1 === null || date1 === undefined) {
    return date2 === null || date2 === undefined;
  }

  if (date2 === null || date2 === undefined) return false;

  return dayjs(date1).isSame(dayjs(date2), "day");
};

export const dateDiff = (
  date1: DateInput,
  date2: DateInput,
  unit?: dayjs.UnitType,
) => {
  if (!date1 && !date2) return 0;
  if (!date1) return 1;
  if (!date2) return -1;

  return dayjs(date1).diff(dayjs(date2), unit);
};
